// borrowed from https://github.com/merlosy/ngx-material-file-input/blob/master/libs/material-file-input/src/lib/validator/file-validator.ts

import { ValidatorFn, AbstractControl } from '@angular/forms';

export class FileValidator {
  /**
   * Function to control content of files
   *
   * @param bytes max number of bytes allowed
   *
   * @returns
   */
  static maxContentSize(bytes: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const size = control && control.value ? (control.value as File[]).map(f => f.size).reduce((acc, i) => acc + i, 0) : 0;
      const condition = bytes >= size;
      return condition
        ? null
        : {
          maxContentSize: {
            actualSize: size,
            maxSize: bytes
          }
        };
    };
  }

  /**
   * Function to control file extensions
   *
   * @param allowedExtensions array of allowed file extensions (e.g., ['.docx', '.pdf'])
   * @param blockedExtensions array of blocked file extensions (e.g., ['.doc'])
   *
   * @returns
   */
  static fileExtension(allowedExtensions?: string[], blockedExtensions?: string[]): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (!control.value || !(control.value as File[]).length) {
        return null;
      }

      const files = control.value as File[];
      for (const file of files) {
        const fileName = file.name.toLowerCase();
        const extension = fileName.substring(fileName.lastIndexOf('.'));

        // Check blocked extensions first
        if (blockedExtensions && blockedExtensions.some(ext => fileName.endsWith(ext.toLowerCase()))) {
          return {
            fileExtension: {
              actualExtension: extension,
              blockedExtensions: blockedExtensions
            }
          };
        }

        // Check allowed extensions if specified
        if (allowedExtensions && allowedExtensions.length > 0) {
          const isAllowed = allowedExtensions.some(ext => fileName.endsWith(ext.toLowerCase()));
          if (!isAllowed) {
            return {
              fileExtension: {
                actualExtension: extension,
                allowedExtensions: allowedExtensions
              }
            };
          }
        }
      }

      return null;
    };
  }
}
